import "pixi";
import "phaser";

import { Game } from "./Game";

window.onload = () => {

    const chessGame = new Game();
};
